const onboarding = {
      "host":"https://onboarding-api.bpclcloud9.com/volo"
}

const bpclProfiles = {
  host: "https://api.bp0.in"
}

export { onboarding, bpclProfiles };
